const autoNgTemplateLoaderTemplate1 = require('./storidgeSnapshotsDatatable.html');

angular.module('portainer.integrations.storidge').component('storidgeSnapshotsDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'GenericDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',
    removeAction: '<',
  },
});
